import React from 'react';
export const defaultTranslations = {
    pluginName: 'Reusable component',
    pluginDescription: 'Reusable Componentt',
};
export const defaultSettings = {
    translations: defaultTranslations,
    Controls: () => React.createElement(React.Fragment, null, " Controls for this plugin were not provided"),
    Renderer: () => React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided "),
    cellStyle: {
        padding: 0,
    },
};
//# sourceMappingURL=settings.js.map